import { apiFetchIntegrations, apiFetchConfiguredIntegrations } from '../../network'
import { AppThunk } from '../store'
import { getAccessToken } from 'lib/authToken'
import {
  integrationsLoading,
  integrationsLoaded,
  totalIntegrationsChanged,
  configuredIntegrationsLoaded
} from './integrationsSlice'

export const fetchIntegrations = (): AppThunk<Promise<any>> => async (dispatch) => {
  const accessToken = getAccessToken()
  if (!accessToken) {
    return
  }

  dispatch(integrationsLoading(true))
  const integrations = await apiFetchIntegrations()
  dispatch(integrationsLoaded({ integrations }))
  dispatch(integrationsLoading(false))
  dispatch(totalIntegrationsChanged(integrations.length))
}

export const fetchConfiguredIntegrations = (): AppThunk<Promise<any>> => async (dispatch) => {
  const accessToken = getAccessToken()
  if (!accessToken) {
    return
  }

  dispatch(integrationsLoading(true))
  const configuredIntegrations = await apiFetchConfiguredIntegrations()
  dispatch(configuredIntegrationsLoaded({ configuredIntegrations }))
  dispatch(integrationsLoading(false))
}
